/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Download_PdfInputs */

const en_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PDF`)
};

const ar_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل PDF`)
};

const bn_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF ডাউনলোড`)
};

const de_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF herunterladen`)
};

const es_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar PDF`)
};

const fr_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger le PDF`)
};

const pt_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar PDF`)
};

const zh_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 PDF`)
};

const tr_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF'yi indir`)
};

const ru_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать PDF`)
};

const pl_resume_download_pdf = /** @type {(inputs: Resume_Download_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz plik PDF`)
};

/**
* | output |
* | --- |
* | "Download PDF" |
*
* @param {Resume_Download_PdfInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_download_pdf = /** @type {((inputs?: Resume_Download_PdfInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Download_PdfInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_download_pdf(inputs)
	if (locale === "bn") return bn_resume_download_pdf(inputs)
	if (locale === "de") return de_resume_download_pdf(inputs)
	if (locale === "es") return es_resume_download_pdf(inputs)
	if (locale === "fr") return fr_resume_download_pdf(inputs)
	if (locale === "pt") return pt_resume_download_pdf(inputs)
	if (locale === "zh") return zh_resume_download_pdf(inputs)
	if (locale === "tr") return tr_resume_download_pdf(inputs)
	if (locale === "ru") return ru_resume_download_pdf(inputs)
	if (locale === "pl") return pl_resume_download_pdf(inputs)
	return en_resume_download_pdf(inputs)
});